import { httpStatuses } from '@reveni-io/reveni-ui'

const hasValue = value => value !== undefined && value !== null && value !== ''

const hasExportDetailData = ({ price, price_currency, country_customs_code, mid_code }) => {
  return [price, price_currency, country_customs_code, mid_code].some(hasValue)
}

const shouldSendExportDetail = exportDetail => Boolean(exportDetail.country) || hasExportDetailData(exportDetail)

export const getExportDetailsPayload = exportDetails => {
  return exportDetails
    ?.filter(shouldSendExportDetail)
    .map(({ country, country_code, price, price_currency, ...extraFields }) => ({
      country_code: country_code || country?.code,
      price,
      price_currency,
      ...extraFields,
    }))
}

export const getEditInfoPayload = ({ item, applyInfoToAllVariants = false }) => ({
  country_code: item?.country?.code,
  hs_code: item.hs_code,
  weight: item.weight,
  weight_unit: item.weight_unit,
  unit_cost: item.unit_cost,
  ...(!applyInfoToAllVariants && { barcode: item.barcode, ns_pid: item.ns_pid }),
  customs_description: item.customs_description,
  taric_code: item.taric_code,
  manufacturer_name: item.manufacturer_name,
  manufacturer_address: item.manufacturer_address,
  apply_to_all_variants: applyInfoToAllVariants,
  export_details: getExportDetailsPayload(item?.export_details),
  product_locations: item?.product_locations?.filter(pl => pl?.location_id),
})

export const isPerVariantFieldError = error => {
  return error?.response?.status === httpStatuses.badRequest && error?.response?.data?.non_field_errors?.length > 0
}

export const getItemWithSavedVariantIdentifiers = (item, product) => {
  const savedItem = product.inventory_items.find(inventoryItem => inventoryItem.id === item.id)

  return { ...item, barcode: savedItem.barcode, ns_pid: savedItem.ns_pid }
}
